/**
 * Fetch user data from MFA verification response JWT token
 */
const fetchUserDataAfterMfa = async (response) => {
  try {
    const token = response.token || response;
    const cleanToken = token.replace('Bearer ', '');

    const tokenParts = cleanToken.split('.');
    if (tokenParts.length !== 3) {
      throw new Error('Invalid JWT token format');
    }

    const payload = JSON.parse(atob(tokenParts[1]));
    const jwtUser = payload.user || payload;

    const userData = {
      id: jwtUser.id,
      username: jwtUser.username,
      role: jwtUser.role,
      firstLogin: false,
      active: 1,
      name: '',
      type: '',
      email: '',
      phone: '',
      city: '',
      address: '',
      patente: '',
      ice: '',
      rc: '',
      raisonSociale: '',
      whatsapp: '',
      code: '',
    };

    return userData;
  } catch (error) {
    console.error('Failed to fetch user data:', error);
    throw error;
  }
};

export default fetchUserDataAfterMfa;
